import { render } from "./LogicReviewApprovalEditor.vue?vue&type=template&id=146b4121&scoped=true"
import script from "./LogicReviewApprovalEditor.vue?vue&type=script&lang=js"
export * from "./LogicReviewApprovalEditor.vue?vue&type=script&lang=js"

import "./LogicReviewApprovalEditor.vue?vue&type=style&index=0&id=146b4121&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146b4121"]])

export default __exports__